const MENTION_TOKENS = ['@channel', '@community'] as const;
export const CHANNEL_MENTION = MENTION_TOKENS[0];
export const COMMUNITY_MENTION = MENTION_TOKENS[1];

export const containsChannelMention = (text: string): boolean =>
  /@channel|@community/i.test(text);

export const containsCommunityMention = (text: string): boolean =>
  /@community/i.test(text);

export const insertChannelMention = (
  text: string,
  cursorPosition: number,
  triggerStart: number,
): string => {
  const before = text.slice(0, triggerStart);
  const after = text.slice(cursorPosition);
  return `${before}${CHANNEL_MENTION} ${after}`;
};

/**
 * Checks if the text before cursor matches @channel typing pattern
 * Returns the match start position or -1 if no match
 */
export const getChannelMentionTriggerPosition = (
  text: string,
  cursorPosition: number,
): number => {
  const textBeforeCursor = text.slice(0, cursorPosition);
  const lastAt = textBeforeCursor.lastIndexOf('@');
  if (lastAt === -1) return -1;

  const token = textBeforeCursor.slice(lastAt);
  const letters = token.slice(1).toLowerCase();
  const matchesChannel = '@channel'.startsWith(token.toLowerCase());
  const matchesCommunity = '@community'.startsWith(token.toLowerCase());

  if (!letters || matchesChannel || matchesCommunity) {
    return lastAt;
  }

  return -1;
};

/**
 * Splits text into parts around @channel mentions for rendering
 * Returns array of { text: string, isChannelMention: boolean }
 */
type TextPart = {
  text: string;
  isChannelMention: boolean;
};

export const splitTextByChannelMention = (text: string): TextPart[] => {
  const mentionRegex = /@channel|@community/g;

  if (!mentionRegex.test(text)) {
    return [{ text, isChannelMention: false }];
  }

  const parts: TextPart[] = [];
  let lastIndex = 0;
  let match;

  mentionRegex.lastIndex = 0;
  while ((match = mentionRegex.exec(text)) !== null) {
    // Add text before the match
    if (match.index > lastIndex) {
      parts.push({
        text: text.slice(lastIndex, match.index),
        isChannelMention: false,
      });
    }

    // Add the @channel mention
    parts.push({
      text: match[0],
      isChannelMention: true,
    });

    lastIndex = mentionRegex.lastIndex;
  }

  // Add remaining text after last match
  if (lastIndex < text.length) {
    parts.push({
      text: text.slice(lastIndex),
      isChannelMention: false,
    });
  }

  return parts;
};
